/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { AddItemToBlockedItemsRequestBody } from '../model/addItemToBlockedItemsRequestBody';
import { HosItem } from '../model/hosItem';
import { RemoveItemFromBlockedItemsRequestBody } from '../model/removeItemFromBlockedItemsRequestBody';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserDetailBlockedItemsService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Mark the item as blocked
     * 
     * @param userId The user id
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addItemToBlockedItems(userId: number, body?: AddItemToBlockedItemsRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addItemToBlockedItems(userId: number, body?: AddItemToBlockedItemsRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addItemToBlockedItems(userId: number, body?: AddItemToBlockedItemsRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addItemToBlockedItems(userId: number, body?: AddItemToBlockedItemsRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling addItemToBlockedItems.');
        }


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.getBasePath()}/api/webtools/v1/users/${encodeURIComponent(String(userId))}/blocked-items`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return Blocked.csv File of Specified by Customer ID
     * 
     * @param userId The customer id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadBlockedItemsAsCsv(userId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public downloadBlockedItemsAsCsv(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public downloadBlockedItemsAsCsv(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public downloadBlockedItemsAsCsv(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling downloadBlockedItemsAsCsv.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.getBasePath()}/api/webtools/v1/users/${encodeURIComponent(String(userId))}/blocked-items/download.csv`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return Blocked.xls File of Specified by Customer ID
     * 
     * @param userId The customer id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadBlockedItemsAsXls(userId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public downloadBlockedItemsAsXls(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public downloadBlockedItemsAsXls(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public downloadBlockedItemsAsXls(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling downloadBlockedItemsAsXls.');
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<any>(`${this.getBasePath()}/api/webtools/v1/users/${encodeURIComponent(String(userId))}/blocked-items/download.xls`,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the blocked items
     * 
     * @param userId The user id
     * @param itemType The item type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBlockedItems(userId: number, itemType?: 'program' | 'track' | 'album', observe?: 'body', reportProgress?: boolean): Observable<Array<HosItem>>;
    public getBlockedItems(userId: number, itemType?: 'program' | 'track' | 'album', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HosItem>>>;
    public getBlockedItems(userId: number, itemType?: 'program' | 'track' | 'album', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HosItem>>>;
    public getBlockedItems(userId: number, itemType?: 'program' | 'track' | 'album', observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getBlockedItems.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (itemType !== undefined && itemType !== null) {
            queryParameters = queryParameters.set('itemType', <any>itemType);
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<HosItem>>(`${this.getBasePath()}/api/webtools/v1/users/${encodeURIComponent(String(userId))}/blocked-items`,
            {
                params: queryParameters,
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unmark the item as blocked
     * 
     * @param userId The user id
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeItemFromBlockedItems(userId: number, body?: RemoveItemFromBlockedItemsRequestBody, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public removeItemFromBlockedItems(userId: number, body?: RemoveItemFromBlockedItemsRequestBody, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public removeItemFromBlockedItems(userId: number, body?: RemoveItemFromBlockedItemsRequestBody, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public removeItemFromBlockedItems(userId: number, body?: RemoveItemFromBlockedItemsRequestBody, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling removeItemFromBlockedItems.');
        }


        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.getBasePath()}/api/webtools/v1/users/${encodeURIComponent(String(userId))}/blocked-items/remove`,
            body,
            {
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
